import axios from "axios";
import setAuthToken from "../utils/setAuthToken";

import {
    GET_FIRE_ALARM_DEVICES,
    GET_FIRE_ALARM_DEVICES_SUCCESS,
    GET_FIRE_ALARM_DEVICES_ERROR,
    GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS,
    GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS_SUCCESS,
    GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS_ERROR,
    CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST,
    CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST_SUCCESS,
    CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST_ERROR,
    FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION,
    FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_SUCCESS,
    FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_ERROR,
    FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_RESET,
    FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT,
    FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT_SUCCESS,
    FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT_ERROR
} from "./types";

export const getAllFireAlarmDevices = () => async (dispatch) => {
    try {
        if (localStorage.token) {
            setAuthToken(localStorage.token);
        }
        dispatch({ type: GET_FIRE_ALARM_DEVICES });
        const res = await axios.get(`/api/FireAlarmRequest/get-devices`);
        dispatch({ type: GET_FIRE_ALARM_DEVICES_SUCCESS, payload: res.data });
    } catch (err) {
        dispatch({ type: GET_FIRE_ALARM_DEVICES_ERROR, payload: err });
    }
};

export const getFireAlarmDisableEnableRequestDetails = (id) => async (dispatch) => {
    try {
        if (localStorage.token) {
            setAuthToken(localStorage.token);
        }
        dispatch({ type: GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS });
        const res = await axios.get(`/api/FireAlarmRequest/get-request?id=${id}&accessLevelId=2`);
        dispatch({ type: GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS_SUCCESS, payload: res.data });
    } catch (err) {
        dispatch({ type: GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS_ERROR, payload: err });
    }
};

export const createFireAlarmDisableEnableRequest = (payload) => async (dispatch) => {
    try {
        if (localStorage.token) {
            setAuthToken(localStorage.token)
        }
        dispatch({ type: CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST });
        const res = await axios.post("/api/FireAlarmRequest/submit", payload);
        dispatch({ type: CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST_SUCCESS, payload: res.data })
    } catch (error) {
        dispatch({ type: CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST_ERROR, payload: error })
    }
}

export const actionFireAlarmDisableEnableRequest = (payload) => async (dispatch) => {
    try {
        if (localStorage.token) {
            setAuthToken(localStorage.token)
        }
        dispatch({ type: FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION });
        const res = await axios.post("/api/FireAlarmRequest/submit-action", payload);
        dispatch({ type: FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_SUCCESS, payload: res.data })
    } catch (error) {
        dispatch({ type: FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_ERROR, payload: error })
    }
}

export const actionFireAlarmDisableEnableRequestReset = () => (dispatch) => {
    dispatch({ type: FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_RESET })
}

export const getFireAlarmDisableEnableReport = (payload) => async (dispatch) => {
    try {
        if (localStorage.token) {
            setAuthToken(localStorage.token)
        }
        dispatch({ type: FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT });
        const res = await axios.get(`/api/reports/get-fire-alarm-enable-disable-request-form?fromDate=${payload.fromDate}&toDate=${payload.toDate}`);
        dispatch({ type: FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT_SUCCESS, payload: res.data })
    } catch (error) {
        dispatch({ type: FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT_ERROR, payload: error })
    }
}